import { useGlobalNavigationHotkeys } from "@permutation-city/ui";
import { Outlet, createRootRoute } from "@tanstack/react-router";
import { UserBalance } from "../components/UserBalance";

export const Route = createRootRoute({
  component: Root,
  notFoundComponent: () => {
    return (
      <p className="text-2xl font-bold text-center mt-24">404 NOT FOUND</p>
    );
  },
});

function Root() {
  useGlobalNavigationHotkeys();

  return (
    <div className="grid grid-rows-[40px_auto] h-full min-w-0 min-h-0">
      <div className="flex items-center justify-end px-4">
        <UserBalance />
      </div>

      <div className="h-full px-4 pb-4">
        <Outlet />
      </div>
    </div>
  );
}
